<div class="form-group row" *ngIf="model.id">
  <app-form-field-display class="col-sm-2" name="id" label="{{'field.identifier.label' | translate}}">{{model.id}}
  </app-form-field-display>
  <app-form-field-display *ngIf="model.updatedAt" class="col-sm-4" name="updatedAt"
    label=" {{'field.lastUpdated.label' | translate}}">{{model.updatedAt | localizedDateTime}}
  </app-form-field-display>
  <app-form-field-display *ngIf="model.updatedUserId" class="col-sm-6" name="updatedUser"
    label="{{'field.lastUpdatedBy.label' | translate}}">{{model.updatedUserId | partyUserEmail | async}}
  </app-form-field-display>
</div>